/* eslint-disable no-await-in-loop */
import chunk from 'lodash/chunk';
import { SalesData } from './sales-data-schema';
import { smartUploadRequestFn } from './smart-upoload-request-fn';

const sleepFn = <T>(ms: number, resolveValue: T) =>
  // eslint-disable-next-line no-promise-executor-return
  new Promise<T>((resolve) => setTimeout(() => resolve(resolveValue), ms));

export const eposUploadPromise = async (params: SalesData, token: string) => {
  const baseChunkedData = chunk(params, 300);
  const chunkedData = chunk(baseChunkedData, 5);

  try {
    const baseRes = [];

    for (let i = 0; i < chunkedData.length; i++) {
      const currentChunk = chunkedData[i];
      const chunkRes = await Promise.all(currentChunk.map((_chunk) => smartUploadRequestFn(_chunk, token)));
      baseRes.push(chunkRes);
      await sleepFn(2000, null); // sleep 2 seconds
    }

    const res = baseRes.flat(2);

    if (res.every((item) => item.success)) {
      return {
        success: true,
      };
    }

    return {
      success: false,
      reason: [...new Set(res.map((item) => item.reason).filter(Boolean))] as Array<string>,
    };
  } catch (e) {
    return {
      success: false,
      reason: [(e as Error)?.message],
    };
  }
};
